var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 34.5V9C99 7.34315 100.343 6 102 6H120.5C122.157 6 123.5 7.34314 123.5 9V119.5C123.5 121.157 122.157 122.5 120.5 122.5H9C7.34315 122.5 6 121.157 6 119.5V103C6 101.343 7.34315 100 9 100H34.5C36.1569 100 37.5 98.6569 37.5 97V73C37.5 71.3431 38.8431 70 40.5 70H66C67.6569 70 69 68.6569 69 67V40.5C69 38.8431 70.3431 37.5 72 37.5H96C97.6569 37.5 99 36.1569 99 34.5Z",
    stroke: "#333333",
    strokeWidth: 11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 11L15.6045 68.9752C13.7079 70.8422 10.5 69.4986 10.5 66.8373V44.3223",
    stroke: "#333333",
    strokeWidth: 11,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasement);
export default __webpack_public_path__ + "static/media/basement.d61ed1b42790211c3977e8ebd22b0b96.svg";
export { ForwardRef as ReactComponent };